// extracted by mini-css-extract-plugin
export default {"inputWrapper":"children-stats_inputWrapper__4oKlz","label":"children-stats_label__WkP7P","textToolTip":"children-stats_textToolTip__PQQz8"};